import { DepositType, OrderStatus, OrderType } from "enums/orders";

export const showStatusText = (key: OrderStatus) => {
  switch (key) {
    case OrderStatus.Pending:
      return "Pending";
    case OrderStatus.Approve:
      return "Approve";
    case OrderStatus.Reject:
      return "Reject";
    case OrderStatus.Processing:
      return "Processing";
    default:
      return "";
  }
};

export const handleColorStatus = (key: OrderStatus) => {
  switch (key) {
    case OrderStatus.Approve:
      return "#10AC02";
    case OrderStatus.Pending:
      return "#EDA10F";
    case OrderStatus.Processing:
      return "#0477FD";
    case OrderStatus.Reject:
      return "#F1212A";
  }
};
